import { TypeChecker } from '@attain-apps/type-guards'

import type { Instance } from './instance'
import { Type } from './type'

export type Key<TType extends Type = Type> = `${typeof Key.PREFIX}${TType}`
export namespace Key {
  export const PREFIX = '$'

  export const isKey = TypeChecker.Factory.custom(
    (val: unknown): val is Key =>
      TypeChecker.isString(val) &&
      val.startsWith(PREFIX) &&
      Type.isType(val.substring(PREFIX.length)),
    {
      typeDescription: 'Instance.Key',
    },
  )

  export function from(instance: Instance): Key | undefined
  export function from<TType extends Type>(type: TType): Key
  export function from(arg: Instance | Type): Key | undefined {
    if (Type.isType(arg)) {
      return `${PREFIX}${arg}`
    }
    return Object.keys(arg).find(
      (key: string): key is Key => isKey(key) && arg[key] !== undefined,
    )
  }
}
